import { render, staticRenderFns } from "./DocumentPriceChangeCRUD.vue?vue&type=template&id=1ed4d3db"
import script from "./DocumentPriceChangeCRUD.vue?vue&type=script&lang=js"
export * from "./DocumentPriceChangeCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports